import { Component } from "react";

class Card extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }


  render() {
    let border = this.props.borderSize ? `border-${this.props.borderSize}` : (this.props.border ? 'border' : '');
    let cardClasses = `row-span-1 lg:col-span-${this.props.width} lg:row-span-${this.props.height} col-span-1 flex flex-col items-${this.props.justify} bg-${this.props.background} text-${this.props.textColor} text-${this.props.justify} bg-${this.props.image} bg-no-repeat bg-${this.props.imagePosition} ${border} border-${this.props.border} rounded-${this.props.borderRadius} p-4 h-full w-full`;
    return (
      <div className={cardClasses}>
        {this.props.children}
      </div>
    );
  }
}

export default Card;